module.exports = __webpack_public_path__ + "img/third_2.1bd65fd7.png";